/**
 * ServiceStripRow — Performance left-strip row.
 *
 * Layout: name + DESC eyebrow + ms (mono) + sparkline + delta %.
 * Phos when active; click toggles active state via `onClick`.
 *
 * Props:
 *   serviceKey:    'merovingian' | 'sati' | 'sentinel' | 'seraph' | 'archivist'
 *   label:         display name
 *   description:   short eyebrow
 *   avgSeconds:    number
 *   deltaPct:      number (positive = slower)
 *   trend:         number[] for the sparkline (optional)
 *   isUp:          true when delta is regressing (amber sparkline)
 *   active:        bool — phos accent
 *   onClick:       () => void
 */

import Sparkline from './Charts/Sparkline';
import { formatSeconds } from '../../../features/statistics/utils';
import styles from './ServiceStripRow.module.css';

export default function ServiceStripRow({
  label,
  description,
  avgSeconds,
  deltaPct = 0,
  trend,
  isUp = false,
  active = false,
  onClick,
}) {
  const positive = deltaPct >= 0;
  const deltaLabel = `${positive ? '+' : ''}${deltaPct.toFixed(1)}%`;
  return (
    <button
      type="button"
      className={`${styles.row} ${active ? styles.active : ''}`}
      onClick={onClick}
    >
      <div className={styles.head}>
        <span className={styles.name}>{label}</span>
        <span className={styles.desc}>{description}</span>
        <span className={styles.spacer} />
        <span className={styles.value}>{formatSeconds(avgSeconds)}</span>
      </div>
      <div className={styles.foot}>
        <span className={styles.spark}>
          {Array.isArray(trend) && trend.length > 0 ? (
            <Sparkline points={trend} isUp={isUp} width={140} height={20} />
          ) : (
            <span className={styles.sparkPlaceholder} />
          )}
        </span>
        <span className={styles.spacer} />
        <span className={`${styles.delta} ${isUp ? styles.deltaUp : ''}`}>{deltaLabel}</span>
      </div>
    </button>
  );
}
